<template>
  <div class="seafirapse between">
    <div class="bqqy flex_start" :style="{height:audoheight}">
      <div class="label">{{ leftText }}</div>
      <div class="taglist flex_start wrap" ref="taglist">
        <div class="tag" 
        v-for="(item,index) in tagify" 
        :key="index"
        @click="condi(index)"
        :class="{ tagactiv: index == status }"
        >{{ item }}</div>
      </div>
    </div>
    <div class="svg" v-if="ishowsvg" @click="isunfold = !isunfold">
      <svg-icon icon-class="jt_right " :class="{ flip90: isunfold }"></svg-icon>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    leftText: {
      type: String,
      default: "擅长领域：",
    },
    tagify: {
      type: Array,
      default() {
        return [
          "婚姻家庭",
          "遗产继承",
          "借款担保",
          "医疗纠纷",
          "房屋土地",
          "交通肇事",
          "名誉及隐私",
          "人身伤害",
          "财产损害",
          "精神赔偿",
          "农林牧渔",
          "消费者维权",
        ];
      },
    },
    showheight:{
      type: Number,
      default: 35,
    }
  },
  data: () => ({
    status: -1,
    isunfold: false,
    ishowsvg:true,
  }),
  computed:{
    audoheight(){
      return this.isunfold?this.$refs.taglist.clientHeight+'px':this.showheight+'px'
    }
  },
  mounted(){
    this.szsvg()
  },
  updated(){
    this.szsvg()
},
  methods: {
    szsvg(){
    this.ishowsvg = this.$refs.taglist.clientHeight>=this.showheight?true:false;
    },
    condi(index) {
      this.status = index;
      if (index == -1) {
        this.$emit("clitag");
      } else {
        this.$emit("clitag", this.tagify[index]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.seafirapse {
  font-size: 16px;
  padding: 5px 0 20px;
  align-items: flex-start;
  .bqqy {
    align-items: flex-start;
    overflow: hidden; 
      transition: all 0.2s;
    .label {
      margin-top: 15px;
      width: 80px;
      font-size: 12px;
      color: #333333;
    }
    .taglist {
      width: 1000px;
      align-items: flex-start;
      .tag {
        margin-top: 15px;
        border-radius: 20px;
        margin-right: 20px;
        padding: 1px 10px;
        font-size: 12px;
        color: #666666;
        cursor: pointer;
        &:hover{
        background: #0465ea;
        color: #fff;
        }
        &.tagactiv{
        background: #0465ea;
        color: #fff;
        }
      }
    }
  }

  .svg {
    margin-top: 15px;
    flex: 1;
    text-align: center;
    position: relative;
    .svg-icon {
      transition: all 0.2s;
    }
    &:hover {
      color: #888;
    }
  }
}
</style>